import NobuVideo from "../objects/nobu-video";
import { selectElement } from "../utils/element-handlers.utils";

function PageHeaderComponent(pageHeaderElement: HTMLElement) {
    const videoElement = pageHeaderElement ? pageHeaderElement.querySelector('video.n-page-header-video') : null;

    if (pageHeaderElement && videoElement) {
        const playPauseButton = pageHeaderElement.querySelector('.n-page-header-video-button');
        var videoInstance = new NobuVideo(videoElement as HTMLVideoElement, playPauseButton as HTMLElement);
        videoInstance.play();
    }
}

export default function initPageHeaderComponent() {
    selectElement('.n-page-header', PageHeaderComponent);
}
